import axios from '../axios'

// レッスン詳細（教材リンク含む）
const getLessonApi = async (lessonId) => {
  return await axios.get(`api/lms/lessons/${lessonId}`)
}

export default getLessonApi
